<!--
 * @Author: your name
 * @Date: 2020-11-19 22:38:59
 * @LastEditTime: 2021-04-06 16:00:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /v-intersection/src/components/box.vue
-->
<template>
  <div class="descBox boxBg">
    <h1 v-if="title">{{ title }}</h1>
    <h3 v-if="desc" v-html="desc">

    </h3>

 

    <div class="iconBox">
      <span v-if="isCodeIcon" class="codeIcon">
        <img src="../assets/code.png" alt="" /></span>
      <span class="copyIcon" v-clipboard="
          () => {

            let noBr = desc.replace(/<br>/gm,'')

            notify();
        
            return  noBr ;
          }
        "><img src="../assets/copy.png" alt="" /></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Box",
  props: ["title", "desc", "isCodeIcon", "descList"],
  methods: {
    notify() {
     
      this.$toast("Copied to clipboard!");
    },
  },
};
</script>

<style lang="scss" scoped>
.descBox {
  position: relative;
  box-sizing: border-box;
  padding: 10px 30px;
  margin-bottom: 5vh;
  max-width: 70vw;
  min-width: 370px;
}

.copyIcon,
.codeIcon {
  padding-left: 1vw;
  img {
    width: 28px;
    height: 28px;
    display: inline-block;
    object-fit: contain;
    cursor: pointer;
    user-select: none;
  }
}

.code {
  text-align: start;
}

.iconBox {
  position: absolute;
  right: 10px;
  top: 10px;
}

</style>
